import React from 'react'
import { Row, Col, Button, Spinner } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import "./Gallery.css";
import BannerImage from "../../assets/cmc.jpg";
import ViewMoreIcon from "../../assets/right-arrow.svg";
import ReactPlayer from "react-player/youtube";
import axios from "../../network/api";
import { useState, useEffect } from "react";
import { baseUrl } from "../../network/Constants";


function Viewmorevideos() {

    const [videoGallery, setVideoGallery] = useState([]);
    const [loading, setLoading] = useState(false);
    
    
      useEffect(() => {
    
        fetchVideoGallery();
      }, []);

      const fetchVideoGallery = (props) => {
        setLoading(true)
        axios
          .get(baseUrl + "/app/video/")
          .then(async (response) => {
            setVideoGallery(response.data);
            setLoading(false)
    
            console.log("HuyyaaVideoGallery: " + JSON.stringify(response.data));
          })
          .catch((error) => {
            console.log(error);
            setLoading(false)
          });
      };

  return (
    <div>
        {videoGallery && (
        <Container>
          <div className="section-title pt-5">Videos</div>
          { loading ?  <div className="loader"><Spinner className="loading-color"/></div>:  <Row className="gallery-images">
            {videoGallery.map((item, index) => {
              return (
                <>
                  <Col lg={6} className="gallery-video" key={index}>
                    <ReactPlayer
                      width="100%"
                      url={item.link}
                      className="youtube-player pt-3"
                    />
                  </Col>
                </>
              );
            })}
          </Row>  }
         
          <div 
          onClick={Viewmorevideos}
          className="view-more ">
            <Button 
             href="/viewmorevideos" 
            className="view-more-btn">
              View More <img src={ViewMoreIcon} /> 
            </Button>
          </div>
        </Container>
      )}
      
    </div>
  )
}

export default Viewmorevideos
